import { render, staticRenderFns } from "./mobile-devices-a45.vue?vue&type=template&id=70e962b1&"
import script from "./mobile-devices-a45.vue?vue&type=script&lang=js&"
export * from "./mobile-devices-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports